// Geo-dependent state variables that might cause hydration issues
const GEO_DEPENDENT_VARIABLES = ['stateUSA', 'state.stateUSA'];

// Pre-compile regex patterns for better performance
const COMPILED_GEO_REGEX = new RegExp(
	GEO_DEPENDENT_VARIABLES.map(
		(variable) => `\\{\\{\\s*${variable.replace('.', '\\.')}\\s*\\}\\}`,
	).join('|'),
);

/**
 * Checks if text contains geo-dependent state variables that could cause hydration issues
 * Optimized version with pre-compiled regex patterns
 */
export const containsGeoDependentVariables = (text: string): boolean => {
	// Early return if no template variables at all
	if (!text.includes('{{')) return false;

	// Use single compiled regex to test all patterns at once
	return COMPILED_GEO_REGEX.test(text);
};
